export const NEXT_PAGE = 'NEXT_PAGE'
export const START_MOBILE_QUIZ = 'START_MOBILE_QUIZ'
export const UPDATE_QUESTION_ONE = 'UPDATE_QUESTION_ONE'
export const UPDATE_MEAT_MULTIPLIER = 'UPDATE_MEAT_MULTIPLIER'
export const UPDATE_MEAT_PERCENT = 'UPDATE_MEAT_PERCENT'
export const UPDATE_FLAVORS = 'UPDATE_FLAVORS'
export const SKIP_QUESTIONS = 'SKIP_QUESTIONS'
export const RESET_QUIZ = 'RESET_QUIZ'
export const SHOW_RESULTS = 'SHOW_RESULTS'
